import { createIcon } from "@chakra-ui/icons";

export const FileDownloadIcon = createIcon({
  displayName: "FileDownloadIcon",
  viewBox: "0 0 20 20",
  path: (
    <path
      d="M16.6673 10.4167V5.66675C16.6673 4.26662 16.6673 3.56655 16.3948 3.03177C16.1552 2.56137 15.7727 2.17892 15.3023 1.93923C14.7675 1.66675 14.0674 1.66675 12.6673 1.66675H7.33398C5.93385 1.66675 5.23379 1.66675 4.69901 1.93923C4.2286 2.17892 3.84615 2.56137 3.60647 3.03177C3.33398 3.56655 3.33398 4.26662 3.33398 5.66675V14.3334C3.33398 15.7335 3.33398 16.4336 3.60647 16.9684C3.84615 17.4388 4.2286 17.8212 4.69901 18.0609C5.23379 18.3334 5.93381 18.3334 7.33387 18.3334H10.4173M11.6673 9.16675H6.66732M8.33398 12.5001H6.66732M13.334 5.83341H6.66732M12.5007 15.8334L15.0007 18.3334M15.0007 18.3334L17.5007 15.8334M15.0007 18.3334V13.3334"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  defaultProps: {
    width: "20px",
    height: "20px",
  },
});
